module.exports = __webpack_public_path__ + "media/images/countryrect/hk-835d1b79861f81fc4187f2fed8aca928.svg";